import React, {Component} from 'react';
import './RadioOptions.scss';

export default class RadioOptions extends Component {
    render() {
        const {options, name, onChange, className, label, uniq} = this.props;
        return (
            <div className={`radio-options ${className}`}>
                {label && <div>{label}</div>}
                <div className="radios">
                    {
                        options.map((option, index) => {
                            let unique_name = uniq ? (option.value + '' + uniq) : option.value;
                            return (
                                <div key={unique_name} className="radio">
                                    <label htmlFor={unique_name}>
                                        <input type="radio" id={unique_name} name={name} onChange={onChange}
                                               checked={option.value === name}/>
                                        <div className="radio-object">
                                            <div className='radio-verticalLine'></div>
                                            <h4>{option.label}</h4>
                                            <div className='radio-verticalLine'></div>
                                        </div>
                                    </label>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}
